export default __webpack_public_path__ + "static/media/subtaskIcon.971fc72f.svg";